import { useMarketing } from 'app/components/analytics-marketing/useMarketing'
import { MarketingShadcnComponent } from 'app/components/analytics-marketing/MarketingShadcnComponent'
export { defaultNonPatientFilter, defaultBecameLeadDateFilter } from 'app/components/analytics-marketing/defaultFilters'

export default function Marketing() {
  const hookData = useMarketing()
  return <MarketingShadcnComponent {...hookData} />
}
